
import { TableConfig } from "@/components/tables/ReusableTablePage";
import { UserProfile, AccessRequest } from "@/types";
import { getUserRowActions } from "./usersRowActions";
import { getUsersColumns } from "./usersColumns";

export const getUsersTableConfig = (
  onEdit: (user: UserProfile | AccessRequest, isRequest: boolean) => void,
  onAddNew: () => void
): TableConfig => {
  return {
    tableName: "users",
    pageTitle: "User Management",
    primaryKeyField: "id",
    columns: getUsersColumns(),
    rowActions: getUserRowActions(onEdit),
    defaultSortColumn: "createdAt",
    defaultSortDirection: "desc",
    searchFields: ["email", "firstName", "lastName", "companyName"],
    addButtonText: "New User",
    onRowClick: (user: UserProfile | AccessRequest) => {
      const isRequest = 'status' in user;
      onEdit(user, isRequest);
    }
  };
};
